import { connect } from 'react-redux';
import { clearUserStatuses, registerUser, clearEmailSent } from '../../actions';
import Register from './component';

export const mapStateToProps = state => (
  {
    registerError: state.user.authError,
    registerSuccess: state.user.authSuccess,
    resendSuccess: state.user.emailSent,
  }
);

export default connect(mapStateToProps, { clearUserStatuses, registerUser, clearEmailSent })(Register);
